<template>
  <div
    :class="[
      'cta',
      { '-light': bg_color === 'light', '-blue': bg_color === 'blue' },
      { '-left': alignment === 'left', '-centered': !alignment || alignment === 'centered' },
    ]"
  >
    <h2 :class="(title_bigger ? 'section' : 'cta') + '__title'" v-reveal>{{ title }}</h2>
    <p class="cta__subtitle" v-reveal>{{ description }}</p>
    <ButtonArrow
      v-for="(button, key) in buttons"
      :key="key"
      :btn="button"
      :parent-bg-color="bg_color"
      v-reveal
      class="-centered"
    />
  </div>
</template>

<script>
import ButtonArrow from '@/components/global/ButtonArrow.vue'

export default {
  name: 'SectionCta',
  components: { ButtonArrow },
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    title_bigger: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: 'Text',
    },
    buttons: {
      type: Array,
    },
    bg_color: {
      type: String,
      default: 'dark',
    },
    alignment: {
      type: String,
      default: 'centered',
    },
  },
}
</script>
